import { ROLES } from "../../../utils/constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: {},
  countryList: [],
  numberReservedStatus: false,
  subscriptionStatus: false,
  isSubscriptionLoading: false,
  isNumberReservedLoading: false,
  subscriptionInfo: [],
  numbersList: null,
  isNumberInTrialAndActive: false,
  workspace: {},
  role: "",
  reservedNumber: "",
  isAgent: false,
  reservationId: "",
  deviceId: "",
  isLoggingOut: false,
  showIFrame: false,
  voipTokens: [],
};

export const sliceKey = "global";

export const globalSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    loadProfile: (state, { payload }) => {
      try {
        state.profile = payload;
        // localStorage.setItem('profileID', payload?.id);
      } catch (e) {
        console.log(e);
      }
    },
    loadCountryList: (state, { payload }) => {
      try {
        state.countryList = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setReservedStatus: (state, { payload }) => {
      try {
        state.numberReservedStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setSubscriptionStatus: (state, { payload }) => {
      try {
        state.subscriptionStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsSubscriptionInfo: (state, { payload }) => {
      try {
        state.subscriptionInfo = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsSubscriptionLoading: (state, { payload }) => {
      try {
        state.isSubscriptionLoading = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsReservedNumberLoading: (state, { payload }) => {
      try {
        state.isNumberReservedLoading = payload;
      } catch (e) {
        console.log(e);
      }
    },

    setNumbersList: (state, { payload }) => {
      try {
        state.numbersList = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsNumberInTrialAndActive: (state, { payload }) => {
      try {
        state.isNumberInTrialAndActive = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setWorkspace: (state, { payload }) => {
      try {
        state.workspace = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setRole: (state, { payload }) => {
      try {
        state.role = payload;
        state.isAgent = state.role === ROLES.AGENT;
      } catch (e) {
        console.log(e);
      }
    },
    setDeviceId: (state, { payload }) => {
      try {
        state.deviceId = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setReservedNumber: (state, { payload }) => {
      try {
        state.reservedNumber = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setReservationId: (state, { payload }) => {
      try {
        state.reservationId = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsLoggingOut: (state, { payload }) => {
      try {
        state.isLoggingOut = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setShowIframe: (state, { payload }) => {
      try {
        state.showIFrame = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setVoipTokens: (state, { payload }) => {
      try {
        state.voipTokens = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const {
  loadProfile,
  loadCountryList,
  setReservedStatus,
  setSubscriptionStatus,
  setIsSubscriptionInfo,
  setIsSubscriptionLoading,
  setIsReservedNumberLoading,
  setNumbersList,
  setIsNumberInTrialAndActive,
  setWorkspace,
  setRole,
  setReservedNumber,
  setReservationId,
  setDeviceId,
  setIsLoggingOut,
  setShowIframe,
  setVoipTokens,
} = globalSlice.actions;

export default globalSlice.reducer;
